<template>
  <div style="background-color: #f4fbff; height: 100%">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="true"
      @onRefreshClick="onRefresh"
    >
    </Header>
    <div class="home home-notice">
      <div class="home_notice-search">
        <form>
          <input
            type="search"
            name="search"
            placeholder="ユーザーまたはチームを検索"
            @search="clearSearch()"
          />
          <input
            type="submit"
            name="submit"
            value="検索"
            onclick="return false;"
          />
        </form>
        <div class="search-btn"><span>絞り込み</span></div>
      </div>

      <div class="home_past-notice">
        <div v-for="(group, date) in groups" :key="date">
          <p class="title-days">{{ formatDate(date) }}</p>
          <div class="past-notice_item "
             :class="{ 'item-case__missed-call': item.calling_type === '不在着信'
              , 'item-case__talking': item.calling_type === '通話中'
              , 'item-case__done': item.calling_type === '通話終了'}"
             v-for="item in group" :key="item.id">
            <p class="item-data">
              <span class="item-time">{{formatTime(item.created_at)}}</span>
            </p>
            <p class="item-info">
              <span class="item-message">{{ item.calling_type }}</span>
              <span class="item-name">{{ item.name }}</span>
            </p>
          </div>
        </div>
      </div>
      <div
        v-show="noticeList.length == 0"
        style="color: #1414ea; text-align: center"
      >
        新しいお知らせはありません
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { GetAllNoticeList } from "@/services/user";
export default {
  data() {
    return {
      noticeList: [],
      noticeListShow: false,
      groups: [],
      refreshNoticeTimer:null,
    };
  },
  components: {
    Header,
  },
  beforeUnmount() {
    if(this.refreshNoticeTimer){
      clearInterval(this.refreshNoticeTimer);
    }
  },
  mounted() {
    this.getAllNoticeList();
    this.refreshNoticeTimer = setInterval(() => {
      this.getAllNoticeList();
    }, 2500);
  },
  methods: {
    getAllNoticeList(){
      GetAllNoticeList().then((res) => {
        this.noticeList = res.data.data;
        this.noticeListShow = true;
        this.groups = this.noticeList.reduce((acc, item) => {
          const date = item.created_at.split(" ")[0];
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(item);
          return acc;
        }, {});
      });
    },
    formatDate(dateStr) {
      const date = new Date(dateStr.replace(/-/g, "/"));
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const weekday =  ["日", "月", "火", "水", "木", "金", "土"][date.getDay()];
      return `${month}/${day}(${weekday})`;
    },
    formatTime(dateStr) {
      return dateStr.slice(11, 16);
    },
    onClickLeft() {
      history.back();
    },
    clearSearch() {
      console.log("1");
    },
  },
  watch: {},
};
</script>

<style scoped>
   
   
  
</style>
